<template>
  <div
    ref="contentModal"
    aria-hidden="true"
    aria-labelledby="helpDocumentModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t("help") }}
          </h5>
          <button
            aria-label="Close"
            class="btn-close"
            data-bs-dismiss="modal"
            data-dismiss="modal"
            type="button"
          ></button>
        </div>
        <div class="modal-body">
          <div class="helpDocument" v-for="helpDocument in helpDocuments" :key="helpDocument.id">
            <h6>{{ helpDocument.title }}</h6>
            <!-- ST143-TI-17771 (c-group 1, KEEP + SANITIZE): back-office WYSIWYG help document description. -->
            <p
              v-if="helpDocument.documentType === 2 && helpDocument.description"
              v-safe-html="helpDocument.description"
            ></p>
            <a
              v-if="helpDocument.documentType === 1 && helpDocument.file"
              :href="getFileDownloadLink(helpDocument.file)"
              class="btn btn-success btnStyle"
            >
              <FontAwesomeIcon icon="fa-light fa-download" class="me-2" />
              {{ helpDocument.file.originalName }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fileManager } from "@/services/file/file-manager";
import { modalMixin } from "@/mixins/modalMixin";

export default {
  name: "HelpDocumentModalComponent",
  mixins: [modalMixin],
  props: {
    helpDocuments: {
      type: Array,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  emits: ["hidden"],
  watch: {
    opened() {
      if (this.opened) {
        this.showModal();
      } else {
        this.hideModal();
      }
    },
  },
  methods: {
    onModalHidden() {
      this.models = [];
      modalMixin.methods.onModalHidden.call(this);
    },

    getFileDownloadLink(file) {
      return fileManager.getDownloadSrc(file);
    },
  },
};
</script>

<style scoped lang="scss">
.helpDocument + .helpDocument {
  border-top: 1px dashed $m-color_6;
  padding-top: 15px;
  margin-top: 15px;
}
</style>
